/* eslint-disable prettier/prettier */
/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/635/interface/api/cat_7056
 */
import { message } from 'ant-design-vue'
import {
  commonConfig_list_post,
  commonConfig_popup_detail_post,
  commonConfig_popup_save_post,
  commonConfig_topbar_detail_post,
  commonConfig_topbar_save_post,
  commonConfig_cookie_detail_post,
  commonConfig_cookie_save_post,
  commonConfig_footerPolicy_detail_post,
  commonConfig_footerPolicy_save_post,
  commonConfig_integratedConfig_detail_post,
  commonConfig_integratedConfig_save_post,
  commonConfig_activity_detail_post,
  commonConfig_activity_save_post,
  commonConfig_page_enum_post
} from 'server/modules/7056'
import dayjs from 'dayjs'
import { cloneDeep } from 'lodash-es'
// 公共功能配置列表

export const commonConfig_list_post_ = async function (state) {
  let postParams = { ...state.postParams }

  if (postParams.status === -1) {
    delete postParams.status
  }

  if (postParams.status === -1) {
    delete postParams.status
  }

  if (postParams.subChannel === -1) {
    delete postParams.subChannel
  }

  if (postParams.navType === -1) {
    delete postParams.navType
  }

  const params = { ...state.pagination, ...postParams, ...state.searchParams }
  const { success, data, retInfo } = await commonConfig_list_post(params)

  if (success) {
    state.dataSource = data
  } else {
    message.error(retInfo)
  }
} // 查询Popup详情

export const commonConfig_popup_detail_post_ = async function (params, state) {
  const {
    success,
    data: data_,
    retInfo
  } = await commonConfig_popup_detail_post(params)
  let data = {
    popupTextDTOS: [],
    ...data_
  }
  data.popupTextDTOS = data && data.popupTextDTOS ? data.popupTextDTOS : []
  let empPopupSet = {
    buttonText: '',
    // 按钮文案
    cookieText: '',
    // cookie提示
    mImgUrl: '',
    //mText
    pcImgUrl: '',
    // 图片url-pc
    pcText: '',
    // 文案-pc
    mText: '',
    // 文案-m
    popupId: '',
    // Email悬浮图
    mEmailSuspendImgUrl: '',
    materialEmailSuspendIdMImg: '',
    materialEmailSuspendMImg: '',
    // SMS悬浮图
    mSmsSuspendImgUrl: '',
    materialSmsSuspendIdMImg: '',
    materialSmsSuspendMImg: ''
  }
  state.popupSet1 = {
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 1),
    type: 1
  }
  state.popupSet2 = {
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 2),
    type: 2
  }
  state.popupSet3 = {
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 3),
    type: 3
  }
  state.popupSet4 = {
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 4),
    type: 4
  }

  state.popupSet5 = {
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 5),
    type: 5
  }

  state.popupSet6 = {
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 6),
    type: 6
  }

  state.popupSet7 = {
    ...empPopupSet,
    subjectName: null,
    couponNum: 1,
    pcImgUrl: null,
    mImgUrl: null,
    ...data.popupTextDTOS.find(item => item.type === 7),
    type: 7
  }

  if (
    state.popupSet7.popupTextCouponDTOList &&
    state.popupSet7.popupTextCouponDTOList.length === 1
  ) {
    state.popupSet7.popupTextCouponDTOList[0].sort = 1
    state.popupSet7.popupTextCouponDTOList.push({
      couponName: '',
      couponViceName: '',
      sort: 2
    })
  }

  if (!state.popupSet7.popupTextCouponDTOList) {
    state.popupSet7.popupTextCouponDTOList = [
      {
        couponName: '',
        couponViceName: '',
        sort: 1
      },
      {
        couponName: '',
        couponViceName: '',
        sort: 2
      }
    ]
  }

  state.popupSet8 = {
    ...empPopupSet,
    subjectName: null,
    couponNum: 1,
    pcImgUrl: null,
    mImgUrl: null,
    ...data.popupTextDTOS.find(item => item.type === 8),
    type: 8
  }

  if (
    state.popupSet8.popupTextCouponDTOList &&
    state.popupSet8.popupTextCouponDTOList.length === 1
  ) {
    state.popupSet8.popupTextCouponDTOList[0].sort = 1
    state.popupSet8.popupTextCouponDTOList.push({
      couponName: '',
      couponViceName: '',
      sort: 2
    })
  }
  if (!state.popupSet8.popupTextCouponDTOList) {
    state.popupSet8.popupTextCouponDTOList = [
      {
        couponName: '',
        couponViceName: '',
        sort: 1
      },
      {
        couponName: '',
        couponViceName: '',
        sort: 2
      }
    ]
  }

  //  10, 11, 12, 13
  const langCode = state.restPopupParams.langs.map(item => {
    return {
      langCode: item.langCode,
      checkboxDefaultChoose: 0
    }
  })

  state.popupSet9 = {
    langs: JSON.parse(JSON.stringify(langCode)),
    checkboxDefaultChoose: 0,
    associatedActivity: 1,
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 9 && !item.peopleType),
    type: 9
  }

  state.popupSet10 = {
    langs: JSON.parse(JSON.stringify(langCode)),
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 10 && !item.peopleType),
    type: 10
  }
  state.popupSet11 = {
    langs: JSON.parse(JSON.stringify(langCode)),
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 11 && !item.peopleType),
    type: 11
  }
  state.popupSet12 = {
    langs: JSON.parse(JSON.stringify(langCode)),
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 12 && !item.peopleType),
    type: 12
  }

  state.popupSet13 = {
    langs: JSON.parse(JSON.stringify(langCode)),
    checkboxDefaultChoose: 0,
    associatedActivity: 1,
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 9 && item.peopleType === 1),
    type: 9
  }

  state.popupSet14 = {
    langs: JSON.parse(JSON.stringify(langCode)),
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 10 && item.peopleType === 1),
    type: 10
  }
  state.popupSet15 = {
    langs: JSON.parse(JSON.stringify(langCode)),
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 11 && item.peopleType === 1),
    type: 11
  }
  state.popupSet16 = {
    langs: JSON.parse(JSON.stringify(langCode)),
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 12 && item.peopleType === 1),
    type: 12
  }

  state.popupSet17 = {
    langs: JSON.parse(JSON.stringify(langCode)),
    checkboxDefaultChoose: 0,
    associatedActivity: 1,
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 9 && item.peopleType === 0),
    type: 9
  }

  state.popupSet18 = {
    langs: JSON.parse(JSON.stringify(langCode)),
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 10 && item.peopleType === 0),
    type: 10
  }
  state.popupSet19 = {
    langs: JSON.parse(JSON.stringify(langCode)),
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 11 && item.peopleType === 0),
    type: 11
  }
  state.popupSet20 = {
    langs: JSON.parse(JSON.stringify(langCode)),
    ...empPopupSet,
    ...data.popupTextDTOS.find(item => item.type === 12 && item.peopleType === 0),
    type: 12
  }

  // 订阅弹框配置phone + email中的样式二
  state.pepopleTabMap = {}
  const style2TextDTOS = data.popupTextDTOS.filter(item => [20,21,22].includes(item.type))
  style2TextDTOS.forEach(item => {
     state.pepopleTabMap[item.peopleType + '-' + item.type] = item.langs.reduce((acc, lang) => {
       acc[lang.langCode] = {
        ...lang
       }
       return acc
     }, {
       peopleType: item.peopleType,
       type: item.type,
       popupId: item.popupId,
       mImgUrl: item.mImgUrl,
       pcImgUrl: item.pcImgUrl,
       mEmailSuspendImgUrl: item.mEmailSuspendImgUrl,
       materialEmailSuspendIdMImg: item.materialEmailSuspendIdMImg,
       materialEmailSuspendMImg: item.materialEmailSuspendMImg,
       mSmsSuspendImgUrl: item.mSmsSuspendImgUrl,
       materialSmsSuspendIdMImg: item.materialSmsSuspendIdMImg,
       materialSmsSuspendMImg: item.materialSmsSuspendMImg,
     })
  })

  if (success) {
    state.popupParams = { ...state.restPopupParams, ...(data ? data : {}) }
    state.popupParams.delayTime =
      state.popupParams?.delayTime === null ? 5 : state.popupParams?.delayTime
  } else {
    message.error(retInfo)
  }
  state.changeTabType()
} // 查询Popup详情

export const commonConfig_popup_save_post_ = async function (params, state) {
  console.log('params ', params)
  for (let item of state.langsList) {
    const langLabel = state.langDic.find(v => v.value === item.langCode)?.label
    if ([null, '', undefined].includes(item.popupParams.sidebarContent) && state.queryParams?.terminalId === '1') {
      return message.warning(
        `多语言${langLabel}下` +
        (item.popupParams.sidebarType - 0 === 1
          ? '请输入侧边栏文本'
          : '请上传侧边栏图片')
      )
    }
  }

  if ([null, '', undefined].includes(params.filterUrl) && state.queryParams?.terminalId === '1') {
    return message.warning('请输入不展示路由')
  }

  const Errors = []
  const tipParams = {
    1: '默认',
    2: '初次订阅成功',
    3: '重新订阅成功',
    4: '注册弹窗配置'
  }

  if (state.popupParams.popType - 0 === 1) {
    params.popupTextDTOS.forEach(sub => {
      for (let dot in sub.langs) {
        const item = sub.langs[dot]
        const langLabel = state.langDic.find(v => v.value === item.langCode)
          ?.label
        item.popupId = params.id

        if (item.type === 1) {
          if (
            !item.buttonText ||
            !item.mImgUrl ||
            !item.pcImgUrl ||
            !item.mText ||
            !item.pcText
          ) {
            return Errors.push(langLabel + ':' + tipParams[item.type])
          }
        }

        if (item.type === 2 || item.type === 3) {
          if (!item.buttonText || !item.mText || !item.pcText) {
            return Errors.push(langLabel + ':' + tipParams[item.type])
          }
        }
      }
    })
  } else {
    if (state.popupParams.popType === 2) {
      params.popupTextDTOS.forEach(sub => {
        for (let dot in sub.langs) {
          const item = sub.langs[dot]
          const langLabel = state.langDic.find(v => v.value === item.langCode)
            ?.label
          item.popupId = params.id
          if (item.type === 4) {
            if (
              !item.buttonTextTwo ||
              !item.buttonText ||
              !item.mImgUrl ||
              !item.pcImgUrl ||
              !item.mText ||
              !item.pcText
            ) {
              return Errors.push(langLabel + ':' + tipParams[item.type])
            }
          }
        }
      })
    }
  }

  if (Errors.length) {
    return message.warning(`请检查${Errors.join(',')}模块数据是否完整`)
  }

  const { success, retInfo } = await commonConfig_popup_save_post(params)
  if (success) {
    message.success(retInfo)
    state.jumpPage()
  } else {
    message.error(retInfo)
  }
} // 查询Topbar详情

export const commonConfig_topbar_detail_post_ = async function (params, state) {
  if (!params?.id) {
    if (!state.topbarParams.topbarItemDTOList) {
      state.topbarParams.topbarItemDTOList = [
        {
          addButton: false,
          color: '#ffffff',
          // 颜色
          countdown: 0,
          // 0 不开启 1 开启
          endTime: null,
          // 倒计时活动结束时间
          link: null,
          // 链接
          orderNum: 0,
          // 顺序
          startTime: null,
          // 活动开始时间
          text: null,
          textColor: '#ffffff',
          // 文案
          topbarConfigId: null // topbar 配置id
        },
        {
          addButton: true,
          color: '#ffffff',
          // 颜色
          countdown: 0,
          // 0 不开启 1 开启
          endTime: null,
          // 倒计时活动结束时间
          link: null,
          // 链接
          orderNum: 0,
          // 顺序
          startTime: null,
          // 活动开始时间
          text: null,
          textColor: '#ffffff',
          // 文案
          topbarConfigId: null // topbar 配置id
        }
      ]
    }
    return
  }
  const { success, data, retInfo } = await commonConfig_topbar_detail_post(
    params
  )

  if (success) {
    state.topbarParams = { ...state.resetTopbarParams, ...(data ? data : {}) }

    if (!state.topbarParams.topbarItemDTOList) {
      state.topbarParams.topbarItemDTOList = [
        {
          addButton: true,
          color: '#ffffff',
          // 颜色
          countdown: 0,
          // 0 不开启 1 开启
          endTime: null,
          // 倒计时活动结束时间
          link: null,
          // 链接
          orderNum: 0,
          // 顺序
          startTime: null,
          // 活动开始时间
          text: null,
          // 文案
          topbarConfigId: null // topbar 配置id
        }
      ]
    }

    state.topbarParams.topbarItemDTOList.forEach(item => {
      if (item.startTime) {
        item.times = [
          dayjs(item.startTime, 'YYYY-MM-DD hh:mm:ss'),
          dayjs(item.endTime, 'YYYY-MM-DD hh:mm:ss')
        ]
      } else {
        item.times = []
      }
    })
    const buttonIdx = state.topbarParams.topbarItemDTOList.findIndex(
      item => item.addButton
    )

    if (buttonIdx === -1) {
      state.topbarParams.topbarItemDTOList.splice(
        state.topbarParams.topbarItemDTOList.length,
        0,
        {
          addButton: true,
          color: '#000000',
          // 颜色
          countdown: 0,
          // 0 不开启 1 开启
          endTime: null,
          // 倒计时活动结束时间
          link: null,
          // 链接
          orderNum: 0,
          // 顺序
          startTime: null,
          // 活动开始时间
          text: null,
          // 文案
          topbarConfigId: null // topbar 配置id
        }
      )
    }
  } else {
    message.error(retInfo)
  }
  state.changeTabType()
} // 保存Topbar

export const commonConfig_topbar_save_post_ = async function (params, state) {
  const cloneParams = cloneDeep(params)

  if (cloneParams.status === undefined) {
    return message.warning('请选择是否启用')
  }
  if (cloneParams.topbarStyle === undefined) {
    return message.warning('请选择样式')
  }

  if (!cloneParams.filterUrl) {
    return message.warning('请输入不展示路由')
  }

  if (!cloneParams.id) {
    delete cloneParams.id
  }

  cloneParams.topbarItemDTOList?.splice(
    cloneParams.topbarItemDTOList.length - 1,
    1
  )
  for (let i = 0; i < cloneParams.topbarItemDTOList.length; i++) {
    const element = cloneParams.topbarItemDTOList[i]

    if (element.countdown - 0 === 2) {
      if (!element.preheatStartTime) {
        return message.warning('预热开始时间不能为空')
      }
      if (element.preheatStartTime >= element.startTime) {
        return message.warning('预热开始时间不能晚于活动开始时间！')
      }
    }
    if (element.countdown - 0 !== 0) {
      if (element.isShow === undefined) {
        return message.error('请选择是否展示')
      }
      if (!element.startTime || !element.endTime) {
        return message.warning('活动起止时间不能为空')
      }
    }
  }
  const Errors = []

  try {
    cloneParams.topbarItemDTOList.forEach((item, index) => {
      if (!item.color) {
        Errors.push(index + 1)
      }

      item.langs.forEach(sub => {
        if ([undefined, '', null].includes(sub.text)) {
          const label = state.langDic.find(v => v.value === sub.langCode)?.label
          Errors.push(index + 1)
          throw { label }
        }
      })

      if (item.countdown && (!item.startTime || !item.endTime)) {
        Errors.push(index + 1)
      }

      item.orderNum = index + 1
      item.topbarConfigId = cloneParams.id
      delete item.times
    })

    if (Errors.length) {
      return message.warning(`请查看Topbar${Errors.join(',')}配置是否填写完整`)
    }
  } catch (error) {
    return message.error(
      `多语言 "${error?.label}" 下的 "Topbar${Errors.join(
        ','
      )}" 当中的 "文案" 不能为空`
    )
  }

  const { success, retInfo } = await commonConfig_topbar_save_post(cloneParams)

  if (success) {
    message.success(retInfo)
    // const query = state.route.query
    // state.router.push({
    //   path: 'TopBarList',
    //   query: pick(query, ['terminalId', 'brandId', 'channelId', 'siteId'])
    // })
  } else {
    message.error(retInfo)
  }
} // 查询cookie详情

export const commonConfig_cookie_detail_post_ = async function (params, state) {
  const { success, data, retInfo } = await commonConfig_cookie_detail_post(
    params
  )

  if (success) {
    if (!data) {
      state.cookieItemList = [
        { ...state.cookieItem },
        {
          isButton: true
        }
      ]
      return
    } else {
      const { status, title, text, filterUrl } = data
      state.postParams = {
        status,
        title,
        text,
        filterUrl
      }
      state.cookieItemList = [
        ...data.cookieItemList,
        {
          isButton: true
        }
      ]
    }

    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 保存cookie

export const commonConfig_cookie_save_post_ = async function (params, state) {
  const { success, retInfo } = await commonConfig_cookie_save_post(params)

  if (success) {
    message.success(retInfo)
    state.initData()
  } else {
    message.error(retInfo)
  }
}

// 查询footer政策条详情
export const commonConfig_footerPolicy_detail_post_ = async function (
  params,
  state
) {
  const {
    success,
    data,
    retInfo
  } = await commonConfig_footerPolicy_detail_post(params)
  if (success) {
    if (data) {
      state.footerPolicyParams = {
        status: data.status - 0, // 0 禁用 1启用
        filterUrl: data.filterUrl
      }
      const footerPolicyItemDTOList = data.footerPolicyItemDTOList || [
        {
          footerPolicyId: null,
          imgUrl: null,
          link: null,
          orderNum: null,
          title: null,
          langs: state?.langDic?.map(v => ({
            langCode: v.value,
            title: null,
            imgUrl: null
          }))
        }
      ]
      state.footerPolicyItemDTOList = [
        ...footerPolicyItemDTOList,
        {
          addButton: true
        }
      ]
    } else {
      state.footerPolicyParams = {
        status: 0, // 0 禁用 1启用
        filterUrl: null
      }
      state.footerPolicyItemDTOList = [
        {
          footerPolicyId: null,
          imgUrl: null,
          link: null,
          orderNum: null,
          title: null,
          itemType: 1,
          langs: state?.langDic?.map(v => ({
            langCode: v.value,
            title: null,
            imgUrl: null
          }))
        },
        {
          addButton: true
        }
      ]
    }
  } else {
    message.error(retInfo)
  }
}

// 保存footer政策条
export const commonConfig_footerPolicy_save_post_ = async function (
  params,
  state
) {
  const { success, retInfo } = await commonConfig_footerPolicy_save_post(params)
  if (success) {
    message.success(retInfo)
    state.initList()
  } else {
    message.error(retInfo)
  }
}

// 查询综合配置详情
export const commonConfig_integratedConfig_detail_post_ = async function (
  params,
  state
) {
  const {
    success,
    data,
    retInfo
  } = await commonConfig_integratedConfig_detail_post(params)
  if (success) {
    if (!data) {
      return
    }
    state.integratedConfig = { ...state.integratedConfig, ...data }
    state.data =
      data.integratedConfigSidebarDTOS?.map(item => ({
        ...item,
        statusM: item.statusM === 1 ? true : false,
        statusPc: item.statusPc === 1 ? true : false
      })) || []
    state.subscriptionComponentList =
      data.subscriptionComponentList?.map(item => ({
        ...item,
        statusM: item.statusM === 1 ? true : false,
        statusPc: item.statusPc === 1 ? true : false
      })) || []
    let socialMediaIconList = state.integratedConfig.socialMediaIconList
    if (
      state.integratedConfig.socialMediaIconList.length === 0 ||
      [null, undefined].includes(socialMediaIconList)
    ) {
      state.integratedConfig = {
        ...state.integratedConfig,
        socialMediaIconList: [
          // {
          //   imgUrl: null,
          //   link: null
          // }
        ]
      }
    }
  } else {
    message.error(retInfo)
  }
  state.changeTabType()
}

// 保存综合配置
export const commonConfig_integratedConfig_save_post_ = async function (
  params,
  state
) {
  const { success, retInfo } = await commonConfig_integratedConfig_save_post(
    params
  )
  if (success) {
    state.initList()
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

export const commonConfig_activity_detail_post_ = async function (
  params,
  state
) {
  const cloneParams = cloneDeep(params)
  const { data } = await commonConfig_activity_detail_post(cloneParams)
  if (data) {
    state.activityFormData = {
      ...data,
      showPage: data.showPage,
      timeSet: [dayjs(data.startTime), dayjs(data.endTime)]
    }
  }
}
export const commonConfig_activity_save_post_ = async function (params, state) {
  const cloneParams = cloneDeep(params)
  const { success, retInfo } = await commonConfig_activity_save_post(
    cloneParams
  )
  if (success) {
    message.success(retInfo)
    state.jumpPage()
  } else {
    message.error(retInfo)
  }
}

export const commonConfig_page_enum_post_ = async function (params, state) {
  const { success, retInfo, data } = await commonConfig_page_enum_post(params)
  if (success) {
    console.log(data)
    data.forEach(item => {
      item.code = item.code.toString()
    })
    state.showPageOptions = data
  } else {
    message.error(retInfo)
  }
}
